import { useMemo } from 'react';

import { MediaPlan } from '@mint-sdk/api-media-plan';

import { useSidebarTreeApi } from '../api/queries/useSidebarTreeApi';

export function useActivityByMediaDataId(
  activityMediaDataId: string | undefined,
): MediaPlan.SidebarItem | null {
  const { data: sidebar } = useSidebarTreeApi();

  return useMemo(() => {
    if (!activityMediaDataId || !sidebar) {
      return null;
    }

    const foundActivity = sidebar.subItems.find(
      (activity) => activity.mediaDataId === activityMediaDataId,
    );

    return foundActivity ?? null;
  }, [activityMediaDataId, sidebar]);
}
